module.exports = __webpack_public_path__ + "images/emoji/honey_pot.bff2489b5e8ec85a83eb.png";